import { create } from 'zustand';
import { authorService, Author, CreateAuthorDto, UpdateAuthorDto, GetPaginationAuthorsDto } from '@/services/authorService';

interface AuthorState {
    authors: Author[];
    pagination: { page: number; limit: number; total: number; totalPages: number };
    selected: Author | null;
    isLoading: boolean;
    isCreating: boolean;
    isUpdating: boolean;
    isDeleting: boolean;
    error: string | null;

    fetchAuthors: (query?: GetPaginationAuthorsDto) => Promise<void>;
    fetchAuthorById: (id: string) => Promise<Author | null>;
    createAuthor: (data: CreateAuthorDto) => Promise<boolean>;
    updateAuthor: (id: string, data: UpdateAuthorDto) => Promise<boolean>;
    deleteAuthor: (id: string) => Promise<boolean>;
    clearSelected: () => void;
}

export const useAuthorStore = create<AuthorState>()((set, get) => ({
    authors: [],
    pagination: { page: 1, limit: 10, total: 0, totalPages: 0 },
    selected: null,
    isLoading: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    error: null,

    fetchAuthors: async (query) => {
        set({ isLoading: true, error: null });
        try {
            const res = await authorService.findAll(query || { page: get().pagination.page, limit: get().pagination.limit });
            if (res.ok && res.data) {
                const data: any = res.data.data;
                set({
                    authors: data?.data?.authors || [],
                    pagination: data?.data?.pagination || { page: 1, limit: 10, total: 0, totalPages: 0 },
                    isLoading: false,
                });
            } else {
                set({ isLoading: false, error: (res as any)?.data?.message || 'Lỗi khi tải tác giả' });
            }
        } catch (e) {
            set({ isLoading: false, error: e instanceof Error ? e.message : 'Lỗi khi tải tác giả' });
        }
    },

    fetchAuthorById: async (id) => {
        try {
            const res = await authorService.findOne(id);
            console.log(res.data.data?.data);
            if (res.ok && res.data) {
                return res.data.data?.data as Author;
            }
            return null;
        } catch {
            return null;
        }
    },

    createAuthor: async (data) => {
        set({ isCreating: true, error: null });
        try {
            const res = await authorService.create(data);
            set({ isCreating: false });
            if (res.ok) {
                await get().fetchAuthors();
                return true;
            }
            return false;
        } catch (e) {
            set({ isCreating: false, error: e instanceof Error ? e.message : 'Lỗi khi tạo tác giả' });
            return false;
        }
    },

    updateAuthor: async (id, data) => {
        set({ isUpdating: true, error: null });
        try {
            const res = await authorService.update(id, data);
            set({ isUpdating: false });
            if (res.ok) {
                await get().fetchAuthors();
                return true;
            }
            return false;
        } catch (e) {
            set({ isUpdating: false, error: e instanceof Error ? e.message : 'Lỗi khi cập nhật tác giả' });
            return false;
        }
    },

    deleteAuthor: async (id) => {
        set({ isDeleting: true, error: null });
        try {
            const res = await authorService.remove(id);
            set({ isDeleting: false });
            if (res.ok) {
                await get().fetchAuthors();
                return true;
            }
            return false;
        } catch (e) {
            set({ isDeleting: false, error: e instanceof Error ? e.message : 'Lỗi khi xóa tác giả' });
            return false;
        }
    },

    clearSelected: () => set({ selected: null }),
}));


